import React, { useState, useEffect, useRef } from 'react';
import styles from './index.module.css';
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

const Index = ({ guests, setGuests, handleCreateGuests }) => {

    const [layoutName, setLayoutName] = useState("default");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [cursorPos, setCursorPos] = useState(0);
    const keyboardRef = useRef(null);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';

        return () => {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
        };
    }, []);

    const layouts = {
        default: [
            "1 2 3 4 5 6 7 8 9 0",
            "Й Ц У К Е Н Г Ш Щ З Х Ъ",
            "Ф Ы В А П Р О Л Д Ж Э",
            "Я Ч С М И Т Ь Б Ю .",
            "{lock} {space} {backspace}"
        ],
        shift: [
            "1 2 3 4 5 6 7 8 9 0",
            "й ц у к е н г ш щ з х ъ",
            "ф ы в а п р о л д ж э",
            "я ч с м и т ь б ю .",
            "{lock} {space} {backspace}"
        ]
    };

    const display = {
        '{backspace}': '⌫',
        '{space}': 'Пробел',
        '{lock}': 'caps'
    };

    const buttonTheme = [
        { class: "hg-space", buttons: "{space}" }
    ];

    const insertAtCursor = (char) => {
        const newVal = guests.slice(0, cursorPos) + char + guests.slice(cursorPos);
        setGuests(newVal);
        if (newVal.length === 1) setLayoutName("shift");
        const newPos = cursorPos + char.length;
        setCursorPos(newPos);
        if (keyboardRef.current) keyboardRef.current.setInput(newVal);
    };

    const onChange = () => {};

    const onKeyPress = (button) => {
        if (button === "{shift}" || button === "{lock}") { handleShift(); return; }
        if (button === "{backspace}") { handleBackspace(); return; }
        if (button === "{space}") { insertAtCursor(" "); return; }
        insertAtCursor(button);
    };

    const handleBackspace = () => {
        if (cursorPos === 0) return;
        const newVal = guests.slice(0, cursorPos - 1) + guests.slice(cursorPos);
        setGuests(newVal);
        setCursorPos(p => p - 1);
        if (keyboardRef.current) keyboardRef.current.setInput(newVal);
    };

    const handleShift = () => {
        setLayoutName(prev => prev === "default" ? "shift" : "default");
    };

    // Определяем позицию курсора по клику на div с текстом
    const handleDisplayClick = (e) => {
        const el = e.currentTarget;
        let charIndex = guests.length;

        const range = document.caretRangeFromPoint
            ? document.caretRangeFromPoint(e.clientX, e.clientY)
            : document.caretPositionFromPoint
                ? (() => { const p = document.caretPositionFromPoint(e.clientX, e.clientY); return p ? { startContainer: p.offsetNode, startOffset: p.offset } : null; })()
                : null;

        if (range && range.startContainer.nodeType === Node.TEXT_NODE) {
            const spanEl = range.startContainer.parentElement;
            const spans = Array.from(el.querySelectorAll('span'));
            const idx = spans.indexOf(spanEl);
            if (idx === 0) charIndex = range.startOffset;
            else if (idx === 2) charIndex = cursorPos + range.startOffset;
        }

        setCursorPos(Math.min(charIndex, guests.length));
    };

    const handleSubmit = async () => {
        if (guests?.length > 0 && !isSubmitting) {
            setIsSubmitting(true);
            try {
                await handleCreateGuests(guests);
            } finally {
                setIsSubmitting(false);
            }
        }
    };

    const handleOverlayTouch = (e) => {
        if (e.target.className.includes('name') && !e.target.className.includes('nameBlock')) {
            e.preventDefault();
        }
    };

    return (
        <div className={styles.name} onTouchMove={handleOverlayTouch}>
            <div className={styles.nameBlock}>
                <div className={styles.nameTitle}>Введите Ваше имя</div>

                <div
                    className={styles.nameInput}
                    onClick={handleDisplayClick}
                    onTouchEnd={handleDisplayClick}
                >
                    <span>{guests.slice(0, cursorPos)}</span>
                    <span className={styles.cursor}>|</span>
                    <span>{guests.slice(cursorPos)}</span>
                </div>

                <Keyboard
                    keyboardRef={r => (keyboardRef.current = r)}
                    className={styles.keyboard}
                    layout={layouts}
                    layoutName={layoutName}
                    onChange={onChange}
                    onKeyPress={onKeyPress}
                    display={display}
                    buttonTheme={buttonTheme}
                />

                <div
                    className={styles.nameButton}
                    onClick={handleSubmit}
                    style={{
                        opacity: isSubmitting ? 0.5 : 1,
                        pointerEvents: isSubmitting ? 'none' : 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    {isSubmitting ? <div className={styles.spinner} /> : 'OK'}
                </div>
            </div>
        </div>
    );
};

export default Index;
